import React from "react";
import MPBossInvoices from "./BossInvoicesComps/MPBossInvoices";

export default function BossInvoices() {
  return (
    <div className="flex-1 h-full">
      <MPBossInvoices />
    </div>
  );
}
